<template>
<b-card header="Return Info">
  <div v-if=usingAmLabel>
    Tracking <a :href=trackingUrl target=_blank>{{trackingNumber}}</a><br/><br/>
    <span>Customer <strong>{{ refundedAmount > 0 ? 'has been' : 'will be' }}</strong> charged {{returnLabelPrice | formatDollars}} for a return shipping label</span>
  </div>
  <div v-else>
    Customer is using their own shipping label for the return
  </div>

  <div v-if="restockFee > 0">Restock Fee: {{restockFee | formatDollars}} ({{restockPercent}}%)</div>
  <div v-if="salesTaxRefund > 0">Sales Tax Refund: {{salesTaxRefund | formatDollars}}</div>
  <div v-if="shippingRefund > 0">Shipping Refund: {{shippingRefund | formatDollars}}</div>
  <br />

  <b-table striped hover :items="returnItems" :fields=columns>
    <template v-for="key in columns" :slot="(!!key['key'] ? key['key'] : key)" slot-scope=row>
      <data-merger :key="(!!key['key'] ? key['key'] : key)" :dict="row.item[(!!key['key'] ? key['key'] : key)]" title="Honestly don't remember" />
    </template>
    <template slot=unitPrice slot-scope=row>
      <data-merger key=unitPrice :dict=row.item.unitPrice formatter=formatDollars title="Unit Price" />
    </template>
  </b-table>
</b-card>
</template>

<script>
import DataMerger from '../../utility/DataMerger.vue';
import orderMerge from '../../../services/orderMerge';

export default {
  props: {
    order: { type: Object, required: true },
  },
  components: {
    DataMerger
  },
  data() {
    return {
      columns: [
        { key: 'sku', label: 'Product' },
        'qty', 'returnReason', 'unitPrice', 'note',
        'returnedQuantity', 'rejectedQuantity', 'refundedQuantity',
      ]
    }
  },
  computed: {
    refundedAmount() {
      return orderMerge.mergeField(this.order.refundedAmount)
    },
    usingAmLabel() {
      if (this.order.websiteName == 'workarea') {
        return orderMerge.mergeField(this.order.providedShippingLabel)
      } else {
        console.warn(`fetching return label info isn't supported for ${this.order.websiteName}`)
        return undefined
      }
    },
    trackingUrl() {
      if (this.order.websiteName == 'workarea') {
        return orderMerge.mergeField(this.order.trackingUrl)
      } else {
        console.warn(`fetching return label info isn't supported for ${this.order.websiteName}`)
        return undefined
      }
    },
    trackingNumber() {
      if (this.order.websiteName == 'workarea') {
        return orderMerge.mergeField(this.order.trackingNumber)
      } else {
        console.warn(`fetching return label info isn't supported for ${this.order.websiteName}`)
        return undefined
      }
    },
    returnLabelPrice() {
      if (this.order.websiteName == 'workarea') {
        return orderMerge.mergeField(this.order.shippingLabelPrice)
      } else {
        console.warn(`fetching return label info isn't supported for ${this.order.websiteName}`)
        return undefined
      }
    },
    restockFee() {
      return orderMerge.mergeField(this.order.restockingFee)
    },
    restockPercent() {
      return Math.round(this.restockFee * 100 / (-1*orderMerge.mergeField(this.order.itemTotal) + this.restockFee))
    },
    salesTaxRefund() {
      return orderMerge.mergeField(this.order.taxTotal)
    },
    shippingRefund() {
      return orderMerge.mergeField(this.order.shippingTotal) - (this.usingAmLabel ? this.returnLabelPrice : 0)
    },
    returnItems() {
      return this.order.items.filter(x => !x['monoSource'] || x['monoSource'] != 'fishbowl')
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/ReturnInfo.vue